/**
 * L'aperçu de ce que Sam vient de dire, quand sa feuille est fermée : du texte simple, sur une
 * ou deux lignes à côté de sa tuile.
 *
 * La règle de l'ancien code (`SamFloatingTile.js`) : 80 caractères au plus, les marques de gras
 * retirées, les blancs resserrés, des points de suspension quand ça coupe. Les formules, elles,
 * arrivent déjà écrites en clair : c'est le view-model qui les convertit, avec le lecteur de
 * formules de l'app, avant d'appeler cette coupe.
 */

/** Au-delà, l'aperçu se coupe. */
export const SAM_PEEK_MAX_CHARS = 80

export function samPeekText(content: string | null | undefined, max: number = SAM_PEEK_MAX_CHARS): string {
    if (content == null) return ""
    const plain = content.replace(/\*\*/g, "").replace(/\s+/g, " ").trim()
    // Par points de code, pas par unités UTF-16 : une coupe au milieu d'un émoji laisserait un
    // demi-caractère illisible avant les points de suspension.
    const chars = Array.from(plain)
    if (chars.length <= max) return plain
    return `${chars
        .slice(0, max - 1)
        .join("")
        .trimEnd()}…`
}
